// date-picker-plugin.js
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
    install(Vue, options = {}) {
        // Register the component with access to i18n
        Vue.component('VueCtkDateTimePicker', {
            extends: VueCtkDateTimePicker,
            computed: {
                localeComputed() {
                    // Get current locale from i18n
                    return this.$i18n ? this.$i18n.locale : 'tr';
                },
                translatedLabel() {
                    return this.$i18n ? this.$i18n.t('dateTimePicker.label_choose_date') : 'Select date & time';
                },

                // Get translations from i18n
                translations() {
                    if (!this.$i18n) return null;

                    return {
                        now: this.$i18n.t('dateTimePicker.now') || 'Now',
                        today: this.$i18n.t('dateTimePicker.today') || 'Today',
                        cancel: this.$i18n.t('dateTimePicker.cancel') || 'Cancel',
                        validate: this.$i18n.t('dateTimePicker.validate') || 'Validate',
                        placeholderDate: this.$i18n.t('dateTimePicker.placeholderDate') || 'Select date sss',
                        placeholderDateTime: this.$i18n.t('dateTimePicker.placeholderDateTime') || 'Select date & time sss',
                        placeholderTime: this.$i18n.t('dateTimePicker.placeholderTime') || 'Select time sss',
                        placeholder: this.$i18n.t('dateTimePicker.placeholderTime') || 'Select time ssss',
                    };
                }
            },
            render(h) {
                // Create props with computed locale
                const props = { 
                    ...this.$props, 
                    locale: this.localeComputed,
                    label:  this.translatedLabel
                };

                // Add translations if available
                if (this.translations) {
                    props.buttonNowTranslation = this.translations.now;
                    props.buttonValidateTranslation = this.translations.validate;
                    props.buttonCancelTranslation = this.translations.cancel;
                    props.buttonTodayTranslation = this.translations.today;

                    // Set placeholder if not already provided
                    if (!props.placeholder) {
                        if (this.$props.onlyTime) {
                            props.placeholder = this.translations.placeholderTime;
                        } else if (this.$props.onlyDate || !this.$props.hasTime) {
                            props.placeholder = this.translations.placeholderDate;
                        } else {
                            props.placeholder = this.translations.placeholderDateTime;
                        }
                    }
                }

                return h(VueCtkDateTimePicker, {
                    props,
                    on: this.$listeners,
                    attrs: this.$attrs,
                    scopedSlots: this.$scopedSlots
                }, this.$slots.default);
            }
        });
    }
}